import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import mask from 'v-mask';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import router from './router';
import store from './store';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@fortawesome/fontawesome-free/css/all.css';

import './utils/msgs';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(mask);
Vue.use(Vuelidate);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
